import { useEffect, useRef } from "react";
import { animate, eases } from "animejs";
import { useNavigate, useLocation } from "react-router-dom";
import MENU from "../../utils/menu";
import { cn } from "../../lib/utils";

const NavigationMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);
  const indicatorRef = useRef(null);
  const itemRefs = useRef([]);

  const activeIndex = Math.max(
    0,
    MENU.findIndex((m) => m.path === location.pathname)
  );

  useEffect(() => {
    const target = itemRefs.current[activeIndex];
    const indicator = indicatorRef.current;
    if (!target || !indicator) return;
    const rect = target.getBoundingClientRect();
    const parentRect = target.parentElement.getBoundingClientRect();
    animate(indicator, {
      translateX: rect.left - parentRect.left,
      width: rect.width,
      duration: 650,
      ease: eases.outElastic(1, 0.7),
    });
  }, [activeIndex]);

  useEffect(() => {
    if (!navRef.current) return;
    animate(navRef.current, {
      translateY: [40, 0],
      opacity: [0, 1],
      duration: 800,
      ease: "outExpo",
      delay: 300,
    });
  }, []);

  return (
    <nav
      ref={navRef}
      className="fixed bottom-6 left-1/2 z-40 -translate-x-1/2 opacity-0"
    >
      <div className="glass-strong relative flex items-center gap-1 rounded-full px-2 py-2 shadow-[0_8px_40px_-8px_rgba(34,211,238,0.4)]">
        <span
          ref={indicatorRef}
          className="absolute left-0 top-1/2 -translate-y-1/2 h-10 rounded-full bg-gradient-to-r from-cyan-500/30 via-fuchsia-500/30 to-violet-500/30 border border-white/15 shadow-[inset_0_0_20px_rgba(34,211,238,0.4)]"
          style={{ width: 0 }}
        />
        {MENU.map((item, i) => {
          const isActive = i === activeIndex;
          return (
            <button
              key={item.path}
              ref={(el) => (itemRefs.current[i] = el)}
              onClick={() => navigate(item.path)}
              className={cn(
                "relative z-10 flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors",
                isActive ? "text-white" : "text-white/60 hover:text-white"
              )}
            >
              {item.icon}
              <span className="hidden sm:inline">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default NavigationMenu;
